import { EDITOR_LS_KEYS } from "@excalidraw/common";

import { EditorLocalStorage } from "../data/EditorLocalStorage";
import { atom } from "../editor-jotai";

import type { TeleprompterSettings, TeleprompterState } from "./types";

const DEFAULT_SETTINGS: TeleprompterSettings = {
  text: "",
  fontSize: 32,
  lineHeight: 1.6,
  scrollSpeed: 40,
  panelOpacity: 0.85,
};

const loadSavedSettings = (): TeleprompterSettings => {
  const saved = EditorLocalStorage.get<Partial<TeleprompterSettings>>(
    EDITOR_LS_KEYS.TELEPROMPTER,
  );
  return saved ? { ...DEFAULT_SETTINGS, ...saved } : DEFAULT_SETTINGS;
};

const DEFAULT_TELEPROMPTER_STATE: TeleprompterState = {
  status: "idle",
  settings: loadSavedSettings(),
  position: { x: -1, y: -1 },
  size: { width: 400, height: 500 },
  scrollOffset: 0,
};

export const teleprompterStateAtom = atom<TeleprompterState>(
  DEFAULT_TELEPROMPTER_STATE,
);

export const teleprompterStatusAtom = atom<TeleprompterState["status"]>(
  (get) => {
    return get(teleprompterStateAtom).status;
  },
);
